module.exports = __webpack_public_path__ + "img/join-banner-sm.b2d9f87d.jpg";